"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSort = exports.editWorkspace = exports.EditWorkspace = exports.EditWorkspaceActionTypes = exports.searchTeams = exports.searchUsers = exports.renameWorkspace = exports.RenameWorkspace = exports.RenameWorkspaceActionTypes = exports.cancelledRenameWorkspace = exports.startRenameWorkspace = exports.addWorkspaceMembers = exports.AddWorkspaceMembers = exports.AddWorkspaceMembersActionTypes = exports.cancelledAssignMembers = exports.assignWorkspaceMembers = exports.cancelWorkspaceMembersDeletion = exports.confirmWorkspaceMembersDeletion = exports.deleteWorkspaceMembers = exports.DeleteWorkspaceMembers = exports.DeleteWorkspaceMembersActionTypes = exports.deselectAllMembersForDelete = exports.selectAllMembersForDelete = exports.deselectMemberForDelete = exports.selectMemberForDelete = exports.selectWorkspace = exports.cancelWorkspaceDeletion = exports.confirmWorkspaceDeletion = exports.deleteWorkspace = exports.DeleteWorkspace = exports.DeleteWorkspaceActionTypes = exports.createWorkspace = exports.CreateWorkspace = exports.CreateWorkspaceActionTypes = exports.deselectMember = exports.selectMember = exports.cancelWorkspaceCreation = exports.updateStagedWorkspace = exports.stageWorkspace = exports.WorkspaceActionTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var WorkspaceActionTypes = (0, _namespacedKeyMirror.default)({
  STAGE_WORKSPACE: null,
  UPDATE_STAGED_WORKSPACE: null,
  CANCELLED_WORKSPACE_CREATION: null,
  SELECT_MEMBER: null,
  DESELECT_MEMBER: null,
  CREATE_WORKSPACE: null,
  DELETE_WORKSPACE: null,
  CONFIRM_WORKSPACE_DELETION: null,
  CANCELLED_WORKSPACE_DELETION: null,
  SELECT_WORKSPACE: null,
  SELECT_MEMBER_FOR_DELETE: null,
  DESELECT_MEMBER_FOR_DELETE: null,
  SELECT_ALL_MEMBERS_FOR_DELETE: null,
  DESELECT_ALL_MEMBERS_FOR_DELETE: null,
  DELETE_WORKSPACE_MEMBERS: null,
  CONFIRM_WORKSPACE_MEMBERS_DELETION: null,
  CANCELLED_WORKSPACE_MEMBERS_DELETION: null,
  ASSIGN_WORKSPACE_MEMBERS: null,
  CANCELLED_ASSIGN_MEMBERS: null,
  ADD_WORKSPACE_MEMBERS: null,
  RENAME_WORKSPACE: null,
  SEARCH_USERS: null,
  SEARCH_TEAMS: null,
  EDIT_WORKSPACE: null,
  UPDATE_SORT: null
}, 'workspaces');
exports.WorkspaceActionTypes = WorkspaceActionTypes;
var stageWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.STAGE_WORKSPACE, (0, _actions.mapPayloadTo)('workspace', 'modalToOpen'));
exports.stageWorkspace = stageWorkspace;
var updateStagedWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.UPDATE_STAGED_WORKSPACE, function (property, value) {
  return {
    properties: (0, _defineProperty2.default)({}, property, value)
  };
});
exports.updateStagedWorkspace = updateStagedWorkspace;
var cancelWorkspaceCreation = (0, _fluxActions.createAction)(WorkspaceActionTypes.CANCELLED_WORKSPACE_CREATION);
exports.cancelWorkspaceCreation = cancelWorkspaceCreation;
var selectMember = (0, _fluxActions.createAction)(WorkspaceActionTypes.SELECT_MEMBER, (0, _actions.mapPayloadTo)('id', 'memberType', 'teamMappings'));
exports.selectMember = selectMember;
var deselectMember = (0, _fluxActions.createAction)(WorkspaceActionTypes.DESELECT_MEMBER, (0, _actions.mapPayloadTo)('id', 'memberType'));
exports.deselectMember = deselectMember;
var CreateWorkspaceActionTypes = (0, _actions.createRequestTypes)(WorkspaceActionTypes.CREATE_WORKSPACE);
exports.CreateWorkspaceActionTypes = CreateWorkspaceActionTypes;
var CreateWorkspace = (0, _actions.createRequestActions)(CreateWorkspaceActionTypes);
exports.CreateWorkspace = CreateWorkspace;
var createWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.CREATE_WORKSPACE, (0, _actions.mapPayloadTo)('workspace', 'authedUser'));
exports.createWorkspace = createWorkspace;
var DeleteWorkspaceActionTypes = (0, _actions.createRequestTypes)(WorkspaceActionTypes.DELETE_WORKSPACE);
exports.DeleteWorkspaceActionTypes = DeleteWorkspaceActionTypes;
var DeleteWorkspace = (0, _actions.createRequestActions)(DeleteWorkspaceActionTypes);
exports.DeleteWorkspace = DeleteWorkspace;
var deleteWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.DELETE_WORKSPACE, (0, _actions.mapPayloadTo)('workspace'));
exports.deleteWorkspace = deleteWorkspace;
var confirmWorkspaceDeletion = (0, _fluxActions.createAction)(WorkspaceActionTypes.CONFIRM_WORKSPACE_DELETION, (0, _actions.mapPayloadTo)('workspace'));
exports.confirmWorkspaceDeletion = confirmWorkspaceDeletion;
var cancelWorkspaceDeletion = (0, _fluxActions.createAction)(WorkspaceActionTypes.CANCELLED_WORKSPACE_DELETION);
exports.cancelWorkspaceDeletion = cancelWorkspaceDeletion;
var selectWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.SELECT_WORKSPACE, (0, _actions.mapPayloadTo)('workspace', 'teams', 'users'));
exports.selectWorkspace = selectWorkspace;
var selectMemberForDelete = (0, _fluxActions.createAction)(WorkspaceActionTypes.SELECT_MEMBER_FOR_DELETE, (0, _actions.mapPayloadTo)('memberKey'));
exports.selectMemberForDelete = selectMemberForDelete;
var deselectMemberForDelete = (0, _fluxActions.createAction)(WorkspaceActionTypes.DESELECT_MEMBER_FOR_DELETE, (0, _actions.mapPayloadTo)('memberKey'));
exports.deselectMemberForDelete = deselectMemberForDelete;
var selectAllMembersForDelete = (0, _fluxActions.createAction)(WorkspaceActionTypes.SELECT_ALL_MEMBERS_FOR_DELETE, (0, _actions.mapPayloadTo)('memberKeys'));
exports.selectAllMembersForDelete = selectAllMembersForDelete;
var deselectAllMembersForDelete = (0, _fluxActions.createAction)(WorkspaceActionTypes.DESELECT_ALL_MEMBERS_FOR_DELETE);
exports.deselectAllMembersForDelete = deselectAllMembersForDelete;
var DeleteWorkspaceMembersActionTypes = (0, _actions.createRequestTypes)(WorkspaceActionTypes.DELETE_WORKSPACE_MEMBERS);
exports.DeleteWorkspaceMembersActionTypes = DeleteWorkspaceMembersActionTypes;
var DeleteWorkspaceMembers = (0, _actions.createRequestActions)(DeleteWorkspaceMembersActionTypes);
exports.DeleteWorkspaceMembers = DeleteWorkspaceMembers;
var deleteWorkspaceMembers = (0, _fluxActions.createAction)(WorkspaceActionTypes.DELETE_WORKSPACE_MEMBERS, (0, _actions.mapPayloadTo)('workspace', 'members'));
exports.deleteWorkspaceMembers = deleteWorkspaceMembers;
var confirmWorkspaceMembersDeletion = (0, _fluxActions.createAction)(WorkspaceActionTypes.CONFIRM_WORKSPACE_MEMBERS_DELETION);
exports.confirmWorkspaceMembersDeletion = confirmWorkspaceMembersDeletion;
var cancelWorkspaceMembersDeletion = (0, _fluxActions.createAction)(WorkspaceActionTypes.CANCELLED_WORKSPACE_MEMBERS_DELETION);
exports.cancelWorkspaceMembersDeletion = cancelWorkspaceMembersDeletion;
var assignWorkspaceMembers = (0, _fluxActions.createAction)(WorkspaceActionTypes.ASSIGN_WORKSPACE_MEMBERS, (0, _actions.mapPayloadTo)('workspace'));
exports.assignWorkspaceMembers = assignWorkspaceMembers;
var cancelledAssignMembers = (0, _fluxActions.createAction)(WorkspaceActionTypes.CANCELLED_ASSIGN_MEMBERS);
exports.cancelledAssignMembers = cancelledAssignMembers;
var AddWorkspaceMembersActionTypes = (0, _actions.createRequestTypes)(WorkspaceActionTypes.ADD_WORKSPACE_MEMBERS);
exports.AddWorkspaceMembersActionTypes = AddWorkspaceMembersActionTypes;
var AddWorkspaceMembers = (0, _actions.createRequestActions)(AddWorkspaceMembersActionTypes);
exports.AddWorkspaceMembers = AddWorkspaceMembers;
var addWorkspaceMembers = (0, _fluxActions.createAction)(WorkspaceActionTypes.ADD_WORKSPACE_MEMBERS, (0, _actions.mapPayloadTo)('workspace', 'userIds', 'teamIds'));
exports.addWorkspaceMembers = addWorkspaceMembers;
var startRenameWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.START_RENAME_WORKSPACE, (0, _actions.mapPayloadTo)('workspace'));
exports.startRenameWorkspace = startRenameWorkspace;
var cancelledRenameWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.CANCELLED_RENAME_WORKSPACE);
exports.cancelledRenameWorkspace = cancelledRenameWorkspace;
var RenameWorkspaceActionTypes = (0, _actions.createRequestTypes)(WorkspaceActionTypes.RENAME_WORKSPACE);
exports.RenameWorkspaceActionTypes = RenameWorkspaceActionTypes;
var RenameWorkspace = (0, _actions.createRequestActions)(RenameWorkspaceActionTypes);
exports.RenameWorkspace = RenameWorkspace;
var renameWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.RENAME_WORKSPACE, (0, _actions.mapPayloadTo)('workspace'));
exports.renameWorkspace = renameWorkspace;
var searchUsers = (0, _fluxActions.createAction)(WorkspaceActionTypes.SEARCH_USERS, (0, _actions.mapPayloadTo)('searchTerm'));
exports.searchUsers = searchUsers;
var searchTeams = (0, _fluxActions.createAction)(WorkspaceActionTypes.SEARCH_TEAMS, (0, _actions.mapPayloadTo)('searchTerm'));
exports.searchTeams = searchTeams;
var EditWorkspaceActionTypes = (0, _actions.createRequestTypes)(WorkspaceActionTypes.EDIT_WORKSPACE);
exports.EditWorkspaceActionTypes = EditWorkspaceActionTypes;
var EditWorkspace = (0, _actions.createRequestActions)(EditWorkspaceActionTypes);
exports.EditWorkspace = EditWorkspace;
var editWorkspace = (0, _fluxActions.createAction)(WorkspaceActionTypes.EDIT_WORKSPACE, (0, _actions.mapPayloadTo)('workspace', 'authedUser'));
exports.editWorkspace = editWorkspace;
var updateSort = (0, _fluxActions.createAction)(WorkspaceActionTypes.UPDATE_SORT, (0, _actions.mapPayloadTo)('data'));
exports.updateSort = updateSort;